
module.exports = (function() {

    return {

        getIpRegion: (entity) => {
            let enclosingRegion = null;
            if (entity.attributes) {
                if (entity.attributes.ipAddress) {
                    if (entity.attributes.ipAddress.cityLabel) {
                        enclosingRegion = entity.attributes.ipAddress.cityLabel;
                    }
                    if (entity.attributes.ipAddress.admin1Label) {
                        if (enclosingRegion && enclosingRegion.length > 0) {
                            enclosingRegion += '-';
                        } else {
                            enclosingRegion = '';
                        }
                        enclosingRegion += entity.attributes.ipAddress.admin1Label;
                    }
                    if (entity.attributes.ipAddress.countryLabel) {
                        if (enclosingRegion && enclosingRegion.length > 0) {
                            enclosingRegion += '-';
                        } else {
                            enclosingRegion = ''; 
                        }
                        enclosingRegion += entity.attributes.ipAddress.countryLabel;
                    }                    
                } else {
                    if (entity.attributes.cityLabel) {
                        enclosingRegion = entity.attributes.cityLabel;
                    }
                    if (entity.attributes.admin1Label) {
                        if (enclosingRegion && enclosingRegion.length > 0) {
                            enclosingRegion += '-';
                        } else {
                            enclosingRegion = '';
                        }
                        enclosingRegion += entity.attributes.admin1Label;
                    }
                    if (entity.attributes.countryLabel) {
                        if (enclosingRegion && enclosingRegion.length > 0) {
                            enclosingRegion += '-';
                        } else {
                            enclosingRegion = ''; 
                        }
                        enclosingRegion += entity.attributes.countryLabel;
                    }   
                }                 
            }
            return enclosingRegion;
        },
        
        getIpCoordinates: (entity) => {
            let coords = null;
            if (entity.attributes) {
                if (entity.attributes.ipAddress) {
                    if (('latitude' in entity.attributes.ipAddress) && ('longitude' in entity.attributes.ipAddress)) {
                        coords = entity.attributes.ipAddress.latitude.toFixed(4) + ',' + entity.attributes.ipAddress.longitude.toFixed(4);
                    }
                } else {
                    if (('latitude' in entity.attributes) && ('longitude' in entity.attributes)) {
                        coords = entity.attributes.latitude.toFixed(4) + ',' + entity.attributes.longitude.toFixed(4);
                    }
                }
            }
            return coords;
        },

        getIpLatitude: (entity) => {
            let lat = null;
            if (entity.attributes) {
                if (entity.attributes.ipAddress) {
                    if ('latitude' in entity.attributes.ipAddress) {
                        lat = entity.attributes.ipAddress.latitude;
                    }
                } else {
                    if ('latitude' in entity.attributes) {
                        lat = entity.attributes.latitude;
                    }
                }
            }
            return lat;
        },

        getIpLongitude: (entity) => {
            let long = null;
            if (entity.attributes) {
                if (entity.attributes.ipAddress) {
                    if ('longitude' in entity.attributes.ipAddress) {
                        long = entity.attributes.ipAddress.longitude;
                    }
                } else {
                    if ('longitude' in entity.attributes) {
                        long = entity.attributes.longitude;
                    }
                }
            }
            return long;
        }
    };
})();
